module.exports = __webpack_public_path__ + "img/question7.1953fba5.png";